export interface ConstructionDocumentItem {
  itemId: string;
  type: 'FILE' | 'FOLDER';
  name: string;
  path: string | null;
  size: number;
  sizeLabel: string;
  modifiedAt: string;
  childCount: number;
}

export interface ConstructionDocumentsResponse {
  items: ConstructionDocumentItem[];
  totalSizeText: string;
  totalSize: number;
  currentCount: number;
}

export interface ConstructionDocumentsGetFileResponse {
  url: string;
}

export enum KnownErrorStates {
  NO_FILES_FOUND = 'noFilesFound',
  NO_FOLDER_FOUND = 'Could not find any folder with name',
  NO_DRIVE_FOUND = 'No drive found for ifs number',
}
